import { Checkbox } from "components/Atoms/inputs/Checkbox";
import React from "react";

interface IProps {
  label: string
  value: server.dto.NotificationTypes
  browserChecked: boolean
  mobileChecked?: boolean
  onBrowserChange: (type: server.dto.NotificationTypes) => void
  onMobileChange?: (type: server.dto.NotificationTypes) => void
}

class NotificationSettingItem extends React.Component<IProps> {
  render(): JSX.Element {
    const { browserChecked, value, label, mobileChecked, onBrowserChange, onMobileChange } = this.props;

    const mobile = mobileChecked != null;

    return (
      <div className="row flex gap-large">
        <div className="grow1">{label}</div>

        <div className="checkboxcell">
          <div>
            <Checkbox
              checked={browserChecked}
              onChange={() => { onBrowserChange(value); }} />
          </div>
        </div>
        <div className="checkboxcell">
          {mobile && <div>
            <Checkbox
              checked={mobileChecked}
              onChange={() => { onMobileChange(value); }} />
          </div>}
        </div>
      </div>
    );
  }
}

export default NotificationSettingItem;
